module.exports = __webpack_public_path__ + "img/triangle-top_hover.1a56ec61.png";